import { types as t, Instance, SnapshotOut } from 'mobx-state-tree';
import WidgetModel from '~/mst/models/widget';
import NodesStore from '~/mst/models/nodes';

const WindRoseWidgetModel = t
  .compose(
    WidgetModel,
    t.model({
      type: 'WindRoseWidget',
      name: t.maybeNull(t.string),
      node_id: t.maybeNull(t.string),
      wind_speed_data_point_id: t.maybeNull(t.string),
      wind_direction_data_point_id: t.maybeNull(t.string),
      nodes: t.maybeNull(NodesStore)
    })
  )
  .named('WindRoseWidget');

export interface IWindRoseWidgetModel extends Instance<typeof WindRoseWidgetModel> {}
export interface IWindRoseWidgetModelSnapshotOut extends SnapshotOut<typeof WindRoseWidgetModel> {}

export default WindRoseWidgetModel;
